import { render } from "./tick.svg?vue&type=template&id=9787b308?inline"
const script = {}
script.render = render

export default script